import { render, staticRenderFns } from "./CompanyTable.vue?vue&type=template&id=183d8e70&scoped=true"
import script from "./CompanyTable.vue?vue&type=script&lang=js"
export * from "./CompanyTable.vue?vue&type=script&lang=js"
import style0 from "./CompanyTable.vue?vue&type=style&index=0&id=183d8e70&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183d8e70",
  null
  
)

export default component.exports